module.exports = __webpack_public_path__ + "media/images/caution-541baac9927ed6d1de992131ca82eebd.svg";